module.exports = __webpack_public_path__ + "static/media/pic-quiz-geldwaescherei-2.386cd437.jpg";